<template>
    <div>
        <div class="review-table" >
            <b-container fluid class="table-responsive" >
                <b-row>
                    <b-col md="auto">
                        <font-awesome-icon 
                            @click="toggleCollapse" 
                            v-if="!visible" 
                            :icon="['fas', 'caret-down']"></font-awesome-icon>
                        <font-awesome-icon 
                            @click="toggleCollapse"
                            v-if="visible" 
                            :icon="['fas', 'caret-up']"></font-awesome-icon>
                    </b-col>
                    <b-col @click="toggleCollapse">
                        <h4>{{checklist.auditCode}} | <span>{{checklist.desc}}</span> </h4>
                    </b-col>
                    <b-col md="auto" v-if="isEditor">
                        <img @click=onEditListDesc(checklist) class="img-fluid edit-img" src="@/assets/img/edit.png">
                    </b-col>
                    <b-col md="auto" v-if="isEditor">
                        <img @click="$emit('deleteList', checklist)" class="img-fluid del-img" src="@/assets/img/delete.png">
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <b-collapse
            :id="'collapse-'+checklist.id"
            v-model="visible">
        <b-container fluid>
            <b-row>
                <b-col md="auto">
                    <div >
                        <b-form-group >
                        <div class="form-row" v-if="isEditor">
                            <b-input-group>
                            <b-input-group-prepend>
                                <b-button @click="onAddItem(checklist)" variant="secondary" v-if="isEditor">Add Item</b-button>
                                <b-button @click="onAddItems(checklist)" variant="secondary" v-if="isEditor">Add Multiple Items</b-button>
                            </b-input-group-prepend>
                            <b-form-select
                                class="form-control clear"
                                label="result"
                                :id='checklist.id + "result"'
                                :options='resultOptionsAll'
                                v-model="allResults"
                                v-on:input="onEditList($event, 'result', questions)">
                            </b-form-select>
                            </b-input-group>
                        </div>
                        </b-form-group>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <div class="review-table" v-if="anyRows">
            <b-container class="form-row">
                <b-row v-if="anySelected && isEditor">
                    <b-col md="auto">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                    </b-col>
                    <b-col md="auto" >
                        <b-form-select
                            class="form-control clear"
                            label="result"
                            :id='checklist.id + "result"'
                            :options='resultOptionsAll'
                            v-model="allResults"
                            v-on:input="onEditList($event, 'result', selected)">
                        </b-form-select>
                    </b-col>
                    <b-col md="auto">
                        <img @click="deleteSelected()" class="img-fluid del-img" src="@/assets/img/delete.png">
                    </b-col>
                </b-row>
            </b-container>
            <div >
               <b-table
                    striped
                    hover
                    :items="questions"
                    :fields="checklistFields"
                    tdClass="text-left"
                    :sort-desc.sync="sortDesc"
                    selectable
                    @row-selected="onRowSelected"
                    sort-by="auditCode"
                >
                    <template v-slot:selected="{ rowSelected }">
                        <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                        </template>
                        <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                        </template>
                    </template>
                    <template v-slot:cell(desc)='data'>
                        <b-container fluid>
                            <b-row>
                                <b-col>
                                    {{data.item.desc}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="auto" v-if="isEditor" @click.stop>
                                    <img @click="$emit('editDesc', data.item)" class="img-fluid edit-img" src="@/assets/img/edit.png">
                                    <img @click="$emit('deleteQuestion', data.item)" class="img-fluid del-img" src="@/assets/img/delete.png">
                                </b-col>
                            </b-row>
                        </b-container>
                    </template>


                    <template v-slot:cell(result)='data'>
                        <div v-if="isEditor" @click.stop>
                            <b-form-select
                                class="form-control clear"
                                :id='data.item.id + "result"'
                                :value='data.item.result'
                                :options='resultOptions'
                                v-on:input="editResult($event, data.item)"
                                >
                            </b-form-select>
                        </div>
                        <div v-if="isReviewer">
                            {{data.item.result}}
                        </div>

                    </template>

                    <template v-slot:cell(completeDate)='data'>
                        <div v-if="(isReviewer && canEditReviews) || isEditor">
                            <b-form-input
                                :id='data.item.id + "date"'
                                type='date'
                                :value='data.item.completeDate'
                                v-on:input="saveCompleteDate($event, 'completeDate', data.item)"
                                >
                            </b-form-input>
                        </div>
                        <!-- <div v-if="isEditor">
                            {{data.item.completeDate}}
                        </div> -->
                    </template>

                    <template v-slot:cell(notes)='data'>
                        <b-container fluid>
                            <b-row>
                                <b-col>
                                    <div class='notesText'>
                                        {{data.item.notes}}
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="auto" v-if="isEditor" @click.stop>
                                    <img @click="$emit('editNote', data.item)" class="img-fluid edit-img" src="@/assets/img/edit.png">
                                    <img @click="onClearNote(data.item)" class="img-fluid del-img" src="@/assets/img/delete.png">
                                </b-col>
                            </b-row>
                        </b-container>
                    </template>

                    <template v-slot:cell(imageData)='data'>
                        <b-container fluid
                            v-for='(item, index) in data.item.imageData'
                            :key='item.imagePath'
                            @click.stop
                        >
                            <b-row>
                                <b-col>
                                    <amplify-s3-image
                                        v-bind:imagePath='item.imagePath'
                                        v-bind:key='item.key'
                                        v-bind:index='index'
                                        v-bind:s3ImageConfig='getS3ImageConf(item)'
                                        >
                                    </amplify-s3-image>
                                </b-col>
                                <b-col md="auto" v-if="isEditor" >
                                    <img @click="deleteImage(data.item, item)" class="img-fluid del-img" src="@/assets/img/delete.png">
                                </b-col>
                            </b-row>
                        </b-container>
                        <img @click.stop @click.exact="$emit('editImage', data.item)" v-if="isEditor" class="img-fluid edit-img" src="@/assets/img/add.png" >
                    </template>

                    <template v-slot:cell(response)='data' v-if=showResponse>
                        {{data.item.response }}
                        <b-button v-b-modal='data.item.id + "response-modal"' @click="editResponse(data.item)" variant=light size="sm" v-if="(isReviewer && canEditReviews) || isEditor">
                            <img class="img-fluid edit-img" src="@/assets/img/edit.png">
                        </b-button>
                        <b-modal
                            :id='data.item.id + "response-modal"'
                            title="Response"
                            v-on:ok='saveResponse($event, data.item)'
                            size='lg'
                            centered
                        >
                            <b-form-textarea
                                type='text'
                                v-model='responseEdit'
                                rows=6
                            >
                            </b-form-textarea>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>
  <b-container v-for="item in sublists" :key="item.id" fluid>
        <b-row>
            <b-col>
                <checklist
                    :checklist="item"
                    :reviewer="reviewer"
                    :canEditReviews="canEditReviews"
                    :filter="filter"
                    v-on:deleteList="onDeleteList"
                    v-on:editDesc="onEditDesc"
                    v-on:deleteQuestion=onDeleteQuestion
                    v-on:deleteQuestions=onDeleteQuestions
                    v-on:editListDesc="onEditListDesc"
                    v-on:editNote='onEditNote'
                    v-on:editImage=onEditImage
                    v-on:clearNote='onClearNote'
                    v-on:addItem=onAddItem
                    v-on:addItems=onAddItems>
                </checklist>
            </b-col>
        </b-row>
    </b-container>
    </b-collapse>
</div>
</template>

<script>
    import {Storage} from 'aws-amplify'
    import v4 from 'uuid'

    export default {
        name: 'Checklist',
        props: [
            "checklist",
            "reviewer",
            "canEditReviews",
            "filter"
        ],
        data() {
            return {
                visible: false,
                selected: [],
                'fields': {
                    'selected': {
                        label:'Selected'
                    },
                    'auditCode': {
                        'label': 'Audit Code',
                        sortable: true
                    },
                    'desc': {
                        'label': 'Description',
                        'tdClass': 'descriptionItem',
                        sortable: true
                    },
                    'result': {
                        label: 'Result',
                        tdClass: 'resultItem',
                        sortable: true

                    },
                    'notes': {
                        label: 'Notes',
                        sortable: true,
                        tdClass: 'notesItem'
                    },
                    'imageData': {
                        label: 'Images',
                        tdClass: 'imageItem'
                    },
                    'completeDate': {
                        label: 'Action Plan Complete Date',
                        tdClass: 'completeDateItem',
                        sortable: true
                    },
                    'response': {
                        label: 'Response',
                        tdClass: 'notesItem',
                        sortable: true
                    }
                },
                "allResults": null,
                "notesEdit": null,
                'responseEdit': null,
                'resultOptions': [
                    { text: 'Clear', value: 'clear' },
                    { text: 'Pass', value: 'pass' },
                    { text: 'Fail', value: 'fail' },
                    { text: 'Not Assessed', value: 'NA' }
                ],
                'resultOptionsAll': [
                    { text: 'Apply to all items', value: null, disabled:true },
                    { text: 'Clear', value: 'clear' },
                    { text: 'Pass', value: 'pass' },
                    { text: 'Fail', value: 'fail' },
                    { text: 'Not Assessed', value: 'NA' }
                ],
                'sortBy': 'auditCode',
                'sortDesc': false,
                "dirty": {},
                s3Conf: {
                    level: 'protected',
                    identityId: 'us-east-2:6e0de6a9-d8bd-44c4-9fc3-9ee68d291243'
                },
                showDeleteModal: false,
            }
        },
        computed: {
            showResponse: function() {
                let a = this.$store.state['currentAudit'].header
                let showResponse = a && (a.state == "in-review" || a.state == "complete")
                return showResponse
            },
            checklistFields: function() {
                let showResponse = this.showResponse
                let fields = [
                    {
                        key: 'auditCode',
                        'label': 'Audit Code',
                        sortable: true
                    },
                    {
                        key: 'desc',
                        'label': 'Description',
                        'tdClass': 'descriptionItem',
                        sortable: true
                    },
                    {
                        key: 'result',
                        label: 'Result',
                        tdClass: 'resultItem',
                        sortable: true
                    },
                    {
                        key: 'notes',
                        label: 'Notes',
                        sortable: true,
                        tdClass: 'notesItem'
                    },
                    {
                        key: 'imageData',
                        label: 'Images',
                        tdClass: 'imageItem'
                    }
                ]
                if( this.anySelected && this.isEditor ) {
                    fields.unshift({
                        key:'selected',
                        label: ''
                    })
                }
                if( showResponse ) {
                    fields.push({
                        key: 'completeDate',
                        label: 'Action Plan Complete Date',
                        tdClass: 'completeDateItem',
                        sortable: true
                    })

                    fields.push({
                        key: 'response',
                        label: 'Response',
                        tdClass: 'notesItem',
                        sortable: true
                    })
                }
                return fields
            },
            questions: function (){
                return this.$store.getters['currentAudit/filteredQuestionsByParent'](this.checklist.id)
            },
            sublists: function() {
                let sub = this.$store.getters['currentAudit/filteredChecklistsByParent'](this.checklist.id)
                if( sub ) {
                    sub = sub.slice()
                    return sub.sort((a,b) => a.auditCode.localeCompare(b.auditCode))
                }
                return sub
            },
            isEditor: function() {
                return !this.reviewer
            },
            isReviewer: function() {
                return this.reviewer
            },
            anySelected: function() {
                return this.selected && this.selected.length > 0
            },
            anyRows: function() {
                return this.questions.length > 0
            }
        },
        methods: {
            onRowSelected: function(selected) {
                console.log("selected rows are ", selected)
                this.selected = selected    
            },
            toggleCollapse: function() {
                this.visible = !this.visible
            },
            editResult: async function(event, question) {
                if(event == 'clear')
                    event = null

                return this.onEditQuestion(event, 'result', question)
            },
            onEditQuestion: async function(event, field, question, force) {
                if (question[field] != event || force) {
                    let updates = []
                    updates.push({
                        field, value:event
                    })
                    this.$store.dispatch('currentAudit/updateQuestion', {item:question, updates})
                    console.log('edit question', event, question)
                    this.dirty[question.id] = true;
                }
                else {
                    console.log(field, "already set to ", event)
                }
            },
            onEditList: async function(event, field, items) {
                this.allResults = null
                if(event == null)
                    return
                if(field == 'result' && event == 'clear')
                    event = null
                this.$store.dispatch('currentAudit/updateQuestions', {questions:items, field, value:event})
            },
            editResponse: function(question) {
                this.responseEdit = question.response
            },
            saveResponse: function(event, question) {
                let newValue = this.responseEdit
                if(newValue == "")
                    newValue = null
                this.$store.dispatch('currentAudit/updateQuestionResponse', {question, field:'response', value:newValue})
                this.responseEdit = ""
            },
            saveCompleteDate: function(event, field, question) {
                if(question.completeDate != event) {
                    let newValue = event
                    this.$store.dispatch('currentAudit/updateQuestionResponseCompleteDate', {question, field:'completeDate', value:newValue})
                }
            },
            deleteImage: async function(item, imgInfo) {
                console.log("deleting ", item, imgInfo, Storage)
                let images = [...item.imageData]
                let idx = item.imageData.findIndex(i => {
                    let match = i.imagePath == imgInfo.imagePath
                    console.log(match, i, imgInfo)
                    return match
                })
                console.log("index was", idx)
                if(idx != -1) {
                    images.splice(idx, 1)
                    Storage.remove(imgInfo.imagePath, {level: 'protected'})
                        .then(result => {
                            console.log("deleted image", result)
                            this.onEditQuestion(images, 'imageData', item, true)
                        })
                        .catch(err => console.log(err))
                }
            },
            genUuid: function () {
                const uuid = v4();
                console.log("Unique id", uuid)
                return uuid
            },
            getS3ImageConf: function(img) {
                return  {
                    level: 'protected',
                    identityId: img.identityId
                }
            },
            onDeleteList: function(list) {
                this.$emit('deleteList', list)
            },
            onEditDesc: function(question) {
                this.$emit('editDesc', question)
            },
            onDeleteQuestion: function(question) {
                this.$emit('deleteQuestion', question)
            },
            onDeleteQuestions: function(question) {
                this.$emit('deleteQuestions', question)
            },
            onEditListDesc: function(list) {
                this.$emit('editListDesc', list)
            },
            onEditNote: function(question) {
                this.$emit('editNote', question)
            },
            onClearNote: function(question) {
                this.$emit('clearNote', question)
            },
            deleteSelected: function() {
                this.$emit('deleteQuestions', this.selected)
            },
            onEditImage: function(question) {
                this.$emit('editImage', question)
            },
            onAddItem: function(checklist) {
                this.$emit('addItem', checklist)
            },
            onAddItems: function(checklist) {
                this.$emit('addItems', checklist)
            }


        }
    }
</script>

<style>
    /* make the images from s3 close to fixed size */
    .amplify-image {
        min-width: 40px;
        max-width: 80px;
    }

    .descriptionItem {
        max-width: 400px;
        text-align: left;
    }

    .resultItem {
        max-width: 100px;
    }

    .dueDateItem {
        max-width: 100px;
    }

    .completeDateItem {
        max-width: 100px;
    }

    .imageItem {
        max-width: 200px;
    }

    .notesItem {
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .notesItem:hover {
        overflow:visible;
        white-space:normal;
    }

    .notesText {
        max-width: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .notesText:hover {
        overflow:visible;
        white-space:normal;
    }
</style>
